<div class="step-connector-wrap">
  <div class="step-icon-base">
    <i [class]="$iconClass()"></i>
  </div>
  @if (!$isLast()) {
    <div class="step-connector"></div>
  }
</div>
<div class="step-content">
  <ng-content />
</div>
